// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '../../../../node_module_clones/recompose';

// Utils
import getEditorJsonWordCount from '../../../../common/tiptap/utils/jsonContentUtils/getEditorJsonWordCount';

// Components

import { useTranslator } from '../../../components/i18n/useTranslator';

const WordCount = ({ rawState }) => {
    const translate = useTranslator('elements', 'elementTypes.document');
    const numberOfWords = rawState ? getEditorJsonWordCount(rawState) : 0;
    const wordKey = numberOfWords === 1 ? 'wordCount.word_one' : 'wordCount.word_other';
    const wordDefault = numberOfWords === 1 ? 'word' : 'words';

    return (
        <span className="WordCount">
            {numberOfWords} {translate(wordKey, wordDefault)}
        </span>
    );
};

WordCount.propTypes = {
    rawState: PropTypes.object,
};

export default pure(WordCount);
